import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppAuthGuard, RoutePath } from '@intrack/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('@intrack-web-app/auth').then((m) => m.AuthModule) },
  {
    path: RoutePath.Dashboard,
    canActivate: [AppAuthGuard],
    canActivateChild: [AppAuthGuard],
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: WelcomePageComponent,
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('@intrack-web-app/intrack-feature/administration').then((m) => m.AdministrationModule),
      },
      {
        path: 'monitoring',
        loadChildren: () => import('@intrack-web-app/intrack-feature/monitoring').then((m) => m.MonitoringModule),
      },
      {
        path: 'delivery-note',
        loadChildren: () => import('@intrack-web-app/intrack-feature/delivery-note').then((m) => m.DeliveryNoteModule),
      },
      {
        path: 'handling-unit',
        loadChildren: () => import('@intrack-web-app/intrack-feature/handling-unit').then((m) => m.HandlingUnitModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('@intrack-web-app/intrack-feature/report').then((m) => m.ReportModule),
      },
      {
        path: 'exports',
        loadChildren: () => import('@intrack-web-app/intrack-feature/exports').then((m) => m.ExportsModule),
      },
      {
        path: 'data-quality',
        loadChildren: () => import('@intrack-web-app/intrack-feature/data-quality').then((m) => m.DataQualityModule),
      },
      {
        path: 'shipment-waybill',
        loadChildren: () =>
          import('@intrack-web-app/intrack-feature/shipment-waybill').then((m) => m.ShipmentWaybillModule),
      },
      {
        path: 'shipment-load',
        loadChildren: () => import('@intrack-web-app/intrack-feature/shipment-load').then((m) => m.ShipmentLoadModule),
      },
      {
        path: 'shipment-to',
        loadChildren: () =>
          import('@intrack-web-app/intrack-feature/shipment-transport-order').then(
            (m) => m.ShipmentTransportOrderModule,
          ),
      },
      {
        path: 'shipment-special-freight',
        loadChildren: () =>
          import('@intrack-web-app/intrack-feature/shipment-special-freight').then(
            (m) => m.ShipmentSpecialFreightModule,
          ),
      },
    ],
  },
  {
    path: 'newsletter',
    loadChildren: () =>
      import('@intrack-web-app/opened-resources/newsletter').then((m) => m.NewsletterSubscriptionModule),
  },
  {
    path: 'proof-of-delivery',
    loadChildren: () =>
      import('@intrack-web-app/opened-resources/proof-of-delivery').then((m) => m.ProofOfDeliveryModule),
  },
  {
    path: 'legal-documents',
    loadChildren: () => import('@intrack-web-app/opened-resources/legal-documents').then((m) => m.LegalDocumentsModule),
  },
  {
    path: 'global-dpn-notice',
    loadChildren: () => import('@intrack-web-app/opened-resources/global-dpn-notice').then((m) => m.GlobalDpnModule),
  },
  {
    path: 'uli',
    redirectTo: 'driver-tour',
  },
  {
    path: 'driver-tour',
    loadChildren: () => import('@intrack-web-app/opened-resources/driver-tour').then((m) => m.DriverTourModule),
  },
  {
    path: 'driver-view',
    loadChildren: () => import('@intrack-web-app/opened-resources/driver-view').then((m) => m.DriverViewModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
